<script>
const BASE_CLASS = 'form-control input-sm'

export default {
  name: 'EmailInput',
  props: {
    toUpper: Boolean,
    value: String,
    disabled: Boolean,
  },
  model: {
    event: 'change',
  },
  data: function () {
    return {
      cssClass: BASE_CLASS,
    }
  },
  methods: {
    pushValue: function ({ target: { value } }) {
      const isNotEmpty = value !== ''
      const isEmailPattern = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g.test(value)
      const rules = [isNotEmpty, isEmailPattern]
      // Validate rules
      const isValid = rules.every((i) => i)
      // Transform
      value = this.toUpper ? value.toUpperCase() : value
      // Set cosmetic
      this.cssClass = !isValid ? BASE_CLASS + ' bd-red' : BASE_CLASS
      // Push out value
      this.$emit('change', value)
    },
  },
}
</script>

<template>
  <input type="text" :class="cssClass" :disabled="disabled" :value="value" @change="pushValue" />
</template>
